import styled from 'styled-components'

export const DialogActions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 24px 16px 24px;

  button {
    margin-bottom: 8px;
  }
`
export const DialogTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px;
  font-size: 18px;
`

export const DialogTitleText = styled.span`
  color: var(--color-neutral-600);
  font-weight: var(--font-weight-semibold);
`
export const DialogTitleIcon = styled.span`
  font-weight: var(--font-weight-semibold);

  ::before {
    content:'X';
  }
`
export const DialogContentText = styled.div`
  color: #3B4A5D;
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  margin-bottom: 8px;
`

export const DialogContentSection = styled.div`
  display: flex;
  align-items: center;
  margin: 8px auto;
  justify-content: space-between;

  p {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: var(--font-weight-regular);
    font-size: 14px;
    color: #3B4A5D;
  }
`

export const DialogWarningSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;

  .warning-header-icon-text {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: .4rem;
    color: var(--color-feedback-danger-300);

    p {
      text-transform: uppercase;
      font-size: .8rem;
      font-weight: var(--font-weight-semibold);
    }
  }

  .warning-header-information-text {
    p {
      font-size: .9rem;
      font-weight: var(--font-weight-semibold);
      text-align: justify;
    }
  }
`

export const DialogOptionsSection = styled.div`
  display: flex;
  gap: .9rem;
  padding: 0 1rem 1rem 1rem;

  span {
    font-size: .9rem !important;
  }

  span.MuiCheckbox-root{
    padding: .3rem !important;
  }
`

